import Api from 'services/api';

export const switchUser = (userId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/switch_user?user_id=${userId}`)
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};
